const ROUTES = {
  HOME: "/",
  LOGIN: "/sign-in",
  SIGNUP: "/sign-up",
  VERIFY_ACCOUNT: "/verify-account",
  TWO_FACTOR_AUTHENTICATION: "/two-factor-authentication",
  SUCCESS_VERIFIED: "/seccess-verified",
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/reset-password",
  UPGRADE_PLAN: "/upgrade-plan",
  PROFILE_PAGE: "/profile-page",
  PROFILE_EDIT_PAGE: "/profile-edit-page",
  MANAGE_CARD_DETAILS: "/manage-card-details",
  MANAGE_CARD: "/manage-card",
  DREAM_RECORD_PAGE: "/-padream-recordge",
  NOTIFICATION: "/notification",
  SUBSCRIPTION_HISTORY: "/subscription-history",
  TRANSACTION_DETAIL: "/transaction-detail/:id",
  CHANGE_PASSWORD: "/change-password",
  ABOUT_US: "/aboutus",
  PRIVACY_POLICY: "/privacy-policy",
  HOW_IT_WORKS: "/how-its-works",
  TERMS_AND_CONDITIONS: "/term-and-conditions",
  DREAM: "/dream",
  NEW_HOME: "/home",
  VOICE_RECORDER: "/voice-recorder",
  CONTENT_PAGE: "/:slug",
  PRIVATE_LAYOUT: "/",
};

export default ROUTES;
